import api from "./api";

/** Testimonio recibido en la postventa, a la espera de curación (HU-06). */
export interface Testimonial {
  _id: string;
  quoteId: string;
  name?: string;
  company?: string;
  text: string;
  /** Autorización expresa del cliente para publicar. */
  allowPublish: boolean;
  proofImageUrl?: string;
  createdAt: string;
}

export interface TestimonialsResponse {
  testimonials: Testimonial[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

/**
 * Revisión de los testimonios recibidos en la postventa (HU-20). Es solo
 * lectura: la publicación en la tienda se cura aparte.
 */
class TestimonialService {
  async getTestimonials(
    params: { page?: number; limit?: number } = {}
  ): Promise<TestimonialsResponse> {
    const response = await api.get("/admin/testimonials", { params });
    return {
      testimonials: response.data.testimonials,
      pagination: response.data.pagination,
    };
  }
}

export default new TestimonialService();
